import { ReactNode } from 'react';

export interface CardProps {
    variant?: 'default' | 'glass' | 'elevated';
    padding?: 'sm' | 'md' | 'lg';
    className?: string;
    children: ReactNode;
}

export function Card({
    variant = 'default',
    padding = 'md',
    className = '',
    children,
}: CardProps) {
    const variantClasses = {
        default: 'bg-gray-800 border border-gray-700',
        glass: 'bg-white/10 backdrop-blur-lg border border-white/20',
        elevated: 'bg-gray-800 shadow-2xl',
    };

    const paddingClasses = {
        sm: 'p-4',
        md: 'p-6',
        lg: 'p-8',
    };

    return (
        <div className={`rounded-xl ${variantClasses[variant]} ${paddingClasses[padding]} ${className}`}>
            {children}
        </div>
    );
}
